.toggle {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.item {
  display: flex;
  align-items: center;
}

.divider {
  padding-inline: 8px;
  color: var(--outline);
}

.active {
  color: var(--ink);
}

.link {
  color: var(--ink-muted);
  /* 44pt tap targets are the app's rule and they apply to a phone browser too. The
     padding does the work without pushing the two words apart on the line. */
  padding-block: 12px;
}

.link:hover {
  color: var(--ink);
}
